"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductCarouselUI = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _uiKit = require("@dbi-tools/ui-kit");

var _ecommerce = require("@dbi-tools/ui-kit/lib/ecommerce");

var _heart = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/heart"));

var _heartFill = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/heart-fill"));

var _pinterest = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/pinterest"));

var _themeOptions = require("../../helpers/theme-options");

var _useStyles = require("../../hooks/useStyles");

var _carouselUi = _interopRequireDefault(require("../carousel/carousel-ui"));

var _const = require("../../const");

var _lazyLoadImage = require("../lazy-load-image");

var _headerTitles = require("../header-titles");

var _price = _interopRequireDefault(require("../price"));

var _productCarousel = require("./product-carousel.styled");

var _style = _interopRequireDefault(require("./style"));

var _const2 = require("./const");

var _notification = require("@dbi-tools/ui-kit/lib/notification");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductCarouselUI = function ProductCarouselUI(_ref) {
  var toasts = _ref.toasts,
      id = _ref.id,
      headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      description = _ref.description,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 4 : _ref$columns,
      layoutWidth = _ref.layoutWidth,
      _ref$mobileLayout = _ref.mobileLayout,
      mobileLayout = _ref$mobileLayout === void 0 ? _const.MobileLayouts.CAROUSEL : _ref$mobileLayout,
      _ref$theme = _ref.theme,
      currentTheme = _ref$theme === void 0 ? _themeOptions.ThemeVariants.WHITE : _ref$theme,
      _ref$removeBottomPadd = _ref.removeBottomPadding,
      removeBottomPadding = _ref$removeBottomPadd === void 0 ? false : _ref$removeBottomPadd,
      _ref$removeTopPadding = _ref.removeTopPadding,
      removeTopPadding = _ref$removeTopPadding === void 0 ? false : _ref$removeTopPadding,
      _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      _ref$favorites = _ref.favorites,
      favorites = _ref$favorites === void 0 ? [] : _ref$favorites,
      handleToggleFavorites = _ref.handleToggleFavorites,
      isSignedIn = _ref.isSignedIn;
  var layoutWidthType = products.length < columns ? _const2.LayoutWidth.IN_SET : layoutWidth || _const2.LayoutWidth.FULL_WIDTH;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      basicEl = _useState2[0],
      setBasicEl = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      decorHeight = _useState4[0],
      setDecorHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      imageHeight = _useState6[0],
      setImageHeight = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isChanging = _useState8[0],
      setIsChanging = _useState8[1];

  var containerRef = (0, _react.useRef)();
  var isScroll = mobileLayout === _const.MobileLayouts.SCROLL;
  var isFullWidth = layoutWidthType === _const2.LayoutWidth.FULL_WIDTH;
  var slidesToShow = Number(products.length < columns ? products.length : columns);
  var evenColumns = products.length < 2 ? 1 : 2;
  var oddColumns = products.length < 3 ? 1 : 3;
  var slidesToShowLg = isScroll ? 1 : isFullWidth ? evenColumns : oddColumns;
  var itemsPerRow = {
    xl: slidesToShow,
    lg: slidesToShowLg,
    md: 1
  };
  var settings = {
    dots: false,
    infinite: !isScroll,
    slidesToShow: slidesToShow,
    swipeToSlide: true,
    onSwipe: function onSwipe() {
      return setIsChanging(true);
    },
    afterChange: function afterChange() {
      return setIsChanging(false);
    },
    lazyLoad: 'progressive',
    responsive: [{
      breakpoint: Number(_uiKit.GridBreakpointsMax.lg),
      settings: {
        slidesToShow: isScroll ? slidesToShowLg + 1 : slidesToShowLg,
        variableWidth: isScroll
      }
    }, {
      breakpoint: Number(_uiKit.GridBreakpointsMax.md),
      settings: {
        slidesToShow: layoutWidthType === _const2.LayoutWidth.IN_SET && isScroll ? 2 : 1,
        variableWidth: isScroll
      }
    }]
  };
  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      type = _themeStrategy$curren.type,
      size = _themeStrategy$curren.size,
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isHalfDarkTheme = isDarkTheme && size === _themeOptions.ThemeSize.HALF;
  var textColor = isDarkTheme && !isHalfDarkTheme ? 'white' : 'gray800';
  var arrowColor = isHalfDarkTheme ? 'light' : 'dark';
  var isInverse = isDarkTheme && !isHalfDarkTheme;

  var updateBasicElement = function updateBasicElement(el) {
    if (!el || !el.offsetWidth) return;
    setBasicEl(el);
  };

  var handleItemClick = function handleItemClick(e, url) {
    if (isChanging) return;
    if (url) window.open("".concat(location.origin, "/").concat(url), '_self');
  };

  var handleFavorites = function handleFavorites(e, id, isWishlisted) {
    e.preventDefault();
    handleToggleFavorites(id, isWishlisted);
  };

  var handlePinterestIconClicked = function handlePinterestIconClicked(e, url) {
    e.preventDefault();
    if (url) window.open("http://pinterest.com/pin/create/link/?url=".concat(url), '_blank');
  };

  var updateValues = function updateValues() {
    var current = containerRef.current;
    if (!current || !basicEl) return;

    var _basicEl$getBoundingC = basicEl.getBoundingClientRect(),
        width = _basicEl$getBoundingC.width,
        top = _basicEl$getBoundingC.top;

    var _getBoundingClientRec = current.getBoundingClientRect(),
        containerTop = _getBoundingClientRec.top;

    var imgHeight = width / 2 * 3;
    var extraPadding = 10;
    setImageHeight(imgHeight);
    setDecorHeight(Math.abs(containerTop - top) + imgHeight / 2 + extraPadding); // 3:2
  };

  (0, _react.useEffect)(function () {
    if (!isHalfDarkTheme) setDecorHeight(0);
    var handleResize = (0, _lodash.debounce)(function () {
      return updateValues();
    }, 200);
    window.addEventListener('resize', handleResize);
    updateValues();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [currentTheme, basicEl, layoutWidthType, removeBottomPadding, removeTopPadding, mobileLayout]);
  (0, _react.useEffect)(function () {
    localStorage.removeItem(_const.LocalStorageValue.BACK_URL_AEM);
  }, []);
  var styles = (0, _useStyles.useStyles)('a', _style.default);
  var desktop = styles.desktop,
      tablet = styles.tablet,
      mobile = styles.mobile;
  var imageSizes = {
    desktop: desktop.Image.absoluteBoundingBox.width,
    tablet: tablet.Image.absoluteBoundingBox.width,
    mobile: mobile.Image.absoluteBoundingBox.width
  };
  var itemsWidth = {
    xl: layoutWidthType === _const2.LayoutWidth.IN_SET ? imageSizes.desktop : 0,
    lg: layoutWidthType === _const2.LayoutWidth.FULL_WIDTH ? 271 : imageSizes.tablet,
    md: imageSizes.mobile
  };
  var theme = {
    $theme: currentTheme,
    $columns: slidesToShow,
    $isLayoutFullWidth: layoutWidthType === _const2.LayoutWidth.FULL_WIDTH,
    $mobileLayout: mobileLayout,
    $itemsPerRow: itemsPerRow,
    $itemsWidth: itemsWidth,
    $decorHeight: decorHeight,
    $imageHeight: imageHeight,
    $styles: styles
  };
  var productProps = {
    favorites: favorites,
    isSignedIn: isSignedIn,
    textColor: textColor,
    handleToggleFavorites: handleToggleFavorites,
    handleFavorites: handleFavorites,
    handlePinterestIconClicked: handlePinterestIconClicked,
    handleItemClick: handleItemClick,
    handleValuesUpdate: updateValues,
    handleBasicElementUpd: updateBasicElement
  };
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_notification.NotificationList, {
    items: toasts
  }), /*#__PURE__*/_react.default.createElement(_productCarousel.StyledBox, {
    removeBottomPadding: removeBottomPadding,
    removeTopPadding: removeTopPadding,
    ref: containerRef,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_PRODUCT_CAROUSEL,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_productCarousel.ContainerStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    p: [0, 20]
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color
  })), /*#__PURE__*/_react.default.createElement(_productCarousel.Wrapp, null, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    settings: settings,
    transparent: true,
    inverse: isInverse,
    arrowStyle: "flat",
    arrowColor: arrowColor
  }, products.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(Product, _extends({
      item: item,
      index: index,
      key: index
    }, productProps));
  }))))));
};

exports.ProductCarouselUI = ProductCarouselUI;

var Product = function Product(_ref2) {
  var _ref2$item = _ref2.item,
      item = _ref2$item === void 0 ? {} : _ref2$item,
      favorites = _ref2.favorites,
      isSignedIn = _ref2.isSignedIn,
      textColor = _ref2.textColor,
      handleToggleFavorites = _ref2.handleToggleFavorites,
      handleFavorites = _ref2.handleFavorites,
      handlePinterestIconClicked = _ref2.handlePinterestIconClicked,
      handleBasicElementUpd = _ref2.handleBasicElementUpd,
      handleValuesUpdate = _ref2.handleValuesUpdate,
      index = _ref2.index;

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      imageUrl = _useState10[0],
      setImageUrl = _useState10[1];

  var isSimple = item.simpleSkuNumber && item.variants && item.variants.find(function (_ref3) {
    var product = _ref3.product;
    return product.sku === item.simpleSkuNumber;
  });
  var variantIndex = item && item.variant_index_data && item.variant_index_data.variants.length ? item.variant_index_data.variants : null;
  var isMockData = !item.variant_index_data;
  var simpleBrand = isSimple && isSimple.product.facet_brand_value.join(', ');
  var brand = isMockData ? "Brand Name ".concat(index + 1) : simpleBrand || item.facet_brand_value.join(', ');
  var simpleName = isSimple && isSimple.product.name;
  var name = isMockData ? item.skuNumber : simpleName || item.name;
  var simplePriceRange = isSimple && isSimple.product.price_range;
  var priceRange = isMockData ? item.priceRange : simplePriceRange || item.price_range;
  var isFav = favorites.includes(item.id);
  var isFirstError = true;
  var simpleImage = isSimple && isSimple.product.descriptive_image;
  var descriptiveImage = item.descriptive_image;
  var configurableImageSrc = isMockData ? "https://via.placeholder.com/193x290" : descriptiveImage ? "".concat(descriptiveImage, "?wid=980") : variantIndex ? "".concat(variantIndex[0].image, "?wid=980") : '';

  var handleError = function handleError() {
    if (simpleImage && isFirstError) {
      setImageUrl(configurableImageSrc);
      isFirstError = false;
    } else {
      setImageUrl('');
    }
  };

  (0, _react.useEffect)(function () {
    simpleImage ? setImageUrl("".concat(simpleImage, "?wid=980")) : setImageUrl(configurableImageSrc);
  }, []);
  var isPinterestBtnShown = !!imageUrl;
  var params = (0, _react.useMemo)(function () {
    var paramString = '';
    if (!isSimple) return paramString;
    isSimple.attributes.map(function (_ref4, index) {
      var code = _ref4.code,
          valueIndex = _ref4.value_index;
      paramString += index > 0 ? '&' : '?';
      paramString += "".concat(code, "=").concat(valueIndex);
    });
    return paramString;
  }, [isSimple]);
  var image = (!!variantIndex || !!isSimple) && imageUrl ? /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: imageUrl,
    alt: "".concat(brand, " ").concat(name),
    title: "View ".concat(brand, " ").concat(name, " in all available colors and sizes"),
    handleError: handleError,
    handleOnLoad: handleValuesUpdate,
    skipLazy: true
  }) : /*#__PURE__*/_react.default.createElement(_ecommerce.ProductImagePlaceholder, null);

  var heartClickHandle = function heartClickHandle(e) {
    e.preventDefault();

    if (isSignedIn) {
      handleToggleFavorites && handleFavorites(e, item.id, isFav);
    } else {
      localStorage.setItem(_const.LocalStorageValue.BACK_URL_AEM, "".concat(window.location.pathname).concat(window.location.search));
      window.open("".concat(window.location.origin, "/sign-in"), '_self');
    }
  };

  return /*#__PURE__*/_react.default.createElement(_productCarousel.Item, {
    href: item.full_url_path && "".concat(window.location.origin, "/").concat(item.full_url_path).concat(params),
    ref: function ref(el) {
      return !index && handleBasicElementUpd(el);
    } // onClick={e => handleItemClick(e, `${item.full_url_path}${params}`)}

  }, /*#__PURE__*/_react.default.createElement(_productCarousel.ImageWrapper, null, isMockData ? /*#__PURE__*/_react.default.createElement(_productCarousel.Preview, null, /*#__PURE__*/_react.default.createElement("span", null, "3:2")) : image), /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: 15
  }, /*#__PURE__*/_react.default.createElement(_productCarousel.Line1, {
    color: textColor
  }, brand), !!name && /*#__PURE__*/_react.default.createElement(_productCarousel.Line2, {
    color: textColor
  }, name.toLowerCase()), /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, !!priceRange && /*#__PURE__*/_react.default.createElement(_price.default, {
    priceRange: priceRange
  }))), /*#__PURE__*/_react.default.createElement(_productCarousel.HeartButton, {
    variant: "link",
    onClick: heartClickHandle,
    isFav: isFav
  }, isFav ? /*#__PURE__*/_react.default.createElement(_heartFill.default, {
    measure: 20
  }) : /*#__PURE__*/_react.default.createElement(_heart.default, {
    measure: 20
  })), isPinterestBtnShown && /*#__PURE__*/_react.default.createElement(_productCarousel.PinterestButton, {
    variant: "link",
    onClick: function onClick(e) {
      return handlePinterestIconClicked(e, imageUrl);
    }
  }, /*#__PURE__*/_react.default.createElement(_pinterest.default, {
    measure: 20
  })));
};

var _default = ProductCarouselUI;
exports.default = _default;